import { mainAxios } from "../mainAxios";
import { getDefaultHeaders, getErrorMessage } from "./mainService";

export const getSolicitudesByIdEmision = async (idEmision) => {
  try {
    const serverResponse = await mainAxios.get(
      `/v1/solicitud/emision/${idEmision}`,
      getDefaultHeaders()
    );

    return serverResponse.data.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const getSolicitudById = async (idSolicitud) => {
  try {
    const serverResponse = await mainAxios.get(
      `/v1/solicitud/id/${idSolicitud}`,
      getDefaultHeaders()
    );

    return serverResponse.data.data.solicitud;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const getSolicitudAndRedencionById = async (idSolicitud) => {
  try {
    const serverResponse = await mainAxios.get(
      `/v1/solicitud/id/${idSolicitud}`,
      getDefaultHeaders()
    );

    return serverResponse.data.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const updateSolicitud = async (body, idSolicitud) => {
  try {
    const serverResponse = await mainAxios.put(
      `/v1/solicitud/editar/${idSolicitud}`,
      body,
      getDefaultHeaders()
    );

    return serverResponse.data.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    } else {
      throw new Error(getErrorMessage(error));
    }
  }
};

export const getSolicitudesByIdCliente = async (idCliente) => {
  try {
    const serverResponse = await mainAxios.post(
      `/v1/solicitud/filtros`,
      {
        cliente: idCliente,
      },
      getDefaultHeaders()
    );

    return serverResponse.data.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const getFolioByCode = async (params) => {
  try {
    const serverResponse = await mainAxios.post(
      `/v1/redencion/folio`,
      params,
      getDefaultHeaders()
    );

    return serverResponse.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const getSolicitudesByFilters = async (filters) => {
  try {
    const serverResponse = await mainAxios.post(
      `/v1/solicitud/filtros`,
      filters,
      getDefaultHeaders()
    );

    return serverResponse.data.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};


export const createSolicitudManual = async (body) => {
  try {
    const serverResponse = await mainAxios.post(
      "/v1/solicitud/manual",
      body,
      getDefaultHeaders()
    );

    return serverResponse.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    } else {
      throw new Error(getErrorMessage(error));
    }
  }
};



export const getSolicitudesCount = async () => {
  try {
    const serverResponse = await mainAxios.get(
      `/v1/solicitud/status/count`,
      getDefaultHeaders()
    );

    return serverResponse.data.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
}; 